<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "old",
  created() {
    localStorage.setItem('loginState',0)
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/old.vue